import React from 'react';
import { Box } from '@mui/material';
import TimelineItem from './TimelineItem';

interface TimelineProps {
    events: any[];
    onDelete: (eventId: number) => void;
}

const Timeline: React.FC<TimelineProps> = ({ events, onDelete }) => {
    return (
        <Box sx={{ position: 'relative', pt: 2 }}>
            {/* Linha vertical da timeline */}
            <Box sx={{
                position: 'absolute',
                left: '24px', // Alinhado com o centro do ícone
                top: '20px',
                bottom: '20px',
                width: '2px',
                backgroundColor: 'divider',
                zIndex: 1,
            }} />
            {events.map((event, index) => (
                <TimelineItem key={event.id || index} event={event} onDelete={onDelete} />
            ))}
        </Box>
    );
};

export default Timeline;
